import { render, staticRenderFns } from "./OrderTimelineCard.vue?vue&type=template&id=67e36b16&"
import script from "./OrderTimelineCard.vue?vue&type=script&lang=js&"
export * from "./OrderTimelineCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports